"use strict";

const InitializeVideoLp = () => {
    const $containerLp = $(".videoLp");

    const handleEvents = () => {
        $containerLp.on("click", (e) => {
            e.preventDefault();

            const $container     = $(e.target).closest(".videoLp");
            const $imgVideoLp    = $container.find(".js-videoLp-img");
            const $titleVideoLp  = $container.find(".js-videoLp-content");
            const $iframeVideoLp = $container.find(".js-videoLp-iframe-content");

            $imgVideoLp.add($titleVideoLp).addClass("d-none");
            $iframeVideoLp.removeClass("d-none");
            const $iframe = $iframeVideoLp.find("iframe");

            $iframe.attr("src", `https://www.youtube.com/embed/${$iframeVideoLp.data("id")}?autoplay=1&mute=1&loop=1&rel=0&wmode=transparent`);
            $iframe.attr("referrerpolicy", "strict-origin-when-cross-origin");
        });
    };

    const init = () => {
        handleEvents();
    };

    init();
};

export default InitializeVideoLp;
